const CACHE_KEY_PREFIX = {
  PROFILE: "profile-cache",
  PROFILE_ACCOUNTS: "profile-accounts-cache",
} as const;

const getCacheKey = (prefix: string, userId: string): string => {
  return `${prefix}-${userId}`;
};

export const getProfileCacheKey = (userId: string): string => {
  return getCacheKey(CACHE_KEY_PREFIX.PROFILE, userId);
};

export const getProfileAccountsCacheKey = (userId: string): string => {
  return getCacheKey(CACHE_KEY_PREFIX.PROFILE_ACCOUNTS, userId);
};

export const getCachedData = <T>(key: string): T | null => {
  try {
    const cached = sessionStorage.getItem(key);
    if (cached) {
      return JSON.parse(cached) as T;
    }
  } catch (error) {
    console.error(`Failed to get cached data for ${key}:`, error);
  }
  return null;
};

export const setCachedData = <T>(key: string, data: T): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error(`Failed to cache data for ${key}:`, error);
  }
};

export const clearProfileCacheByUserId = (
  userId: string | null | undefined,
): void => {
  if (!userId) return;

  try {
    sessionStorage.removeItem(getProfileCacheKey(userId));
    sessionStorage.removeItem(getProfileAccountsCacheKey(userId));
  } catch (error) {
    console.error("Failed to clear profile cache:", error);
  }
};

export const clearProfileCacheByUserIds = (
  userIds: (string | null | undefined)[],
): void => {
  userIds.forEach((userId) => clearProfileCacheByUserId(userId));
};

export const clearProfileCacheByJwtTokenData = (jwtTokenData: {
  sub?: string | null;
  preferred_username?: string | null;
}): void => {
  clearProfileCacheByUserIds([jwtTokenData.sub, jwtTokenData.preferred_username]);
};
